<template>
    <div style="position: relative" id="risk-score-container">
        <div class="col-xs-3" style="height: 100%; padding:0" v-show="largeScreen  && this.sortedArray.length">
            <div v-show="!loading">
                <dashboard-item-menu
                    ref="riskScoreDashboardItemMenu"
                    :titleColor="mainTitleColor"
                    :titleBackgroundColor="mainTitleBackgroundColor"
                    :title="mainTitle"
                    :menuList="riskScoreMenuList"
                    @menuItemClicked="onCategorySelect"
                    :customerAvatar="this.getComodoUserLogo"
                ></dashboard-item-menu>
            </div>
        </div>
        <div class="col-xs-9" style="height: 100%; position: relative;" v-show="largeScreen  && this.sortedArray.length">
            <div v-show="overallRiskSelected">
                <overall-risk
                    :sortedFiles='this.sortedArray'
                    :files='riskScoreItem'
                    @selectRisk="selectRisk"
                    :is_send_threat_email_disabled="is_send_threat_email_disabled()"
                    @send_threat_email="sendThreatEmail"
                ></overall-risk>
            </div>
            <div v-show="subRiskSelected">
                <sub-risk-dasboard-view ref="subRiskDashboardView"
                                        :is_send_threat_email_disabled="is_send_threat_email_disabled()"
                                        @send_threat_email="sendThreatEmail"
                                        :files='riskScoreItem'></sub-risk-dasboard-view>
            </div>
        </div>
        <div class="partner-is-calculating-div" style="height: 100%; position:relative;"
             v-show="!this.sortedArray.length && !this.loading">
            <img src="../../../assets/threat-calculating.png"/>
            <h4 style="color: white; width: 70%; padding-top: 24px" align="center">Your threat score will be calculated
                in a few minutes.
            </h4>
            <h4 style="color: white; width: 70%" align="center">In the mean time you may check other pages.</h4>
        </div>

        <!-- Large Size Start -->
        <div v-show="!largeScreen">
            <risk-score-large
                v-show="!this.loading && this.sortedArray.length"
                :sortedFiles='this.sortedArray'
                :files='riskScoreItem'
                :is_send_threat_email_disabled="is_send_threat_email_disabled()"
                @send_threat_email="sendThreatEmail"
            ></risk-score-large>
        </div>
        <!-- Large Size End -->
        <div class="enlarge-button grow" @click="onEnlargeClick" v-show="!loading">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <loading-modal v-if="loading" :color="'blue'"></loading-modal>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import LoadingModal from "@/components/modals/LoadingModal";

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "#C9C9C9";
    const MENU_ITEM_BACKGROUND_COLOR = "#7F7F7F";
    const MENU_ITEM_COLOR = "rgb(63,92,111)";
    const MENU_TITLE_COLOR = "white";
    const RISK_SCORE_MENU_ITEM_COUNT = 6;
    const RISK_SCORE_MENU_ITEM_TEXTS = [];

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';
    import OverallRisk from "../../../components/risk-score/OverallRisk";
    import SubRiskDasboardView from "../../../components/risk-score/SubRiskDashboardView"
    import RiskScoreLarge from "./RiskScoreLarge";

    export default {
        name: "risk-score",
        components: {
            SubRiskDasboardView,
            RiskScoreLarge,
            OverallRisk,
            DashboardItemMenu: DashboardItemMenu,
            LoadingModal: LoadingModal
        },
        props: {
            itemNumber: {
                type: Number,
                required: true
            }
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'THREAT\nSCORE',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                loading: false,
                riskScoreMenuList: [],
                riskScoreItem: {},
                overallRiskSelected: false,
                subRiskSelected: false,
                sub_risk_source: {},
                selectedCategoryItem: {},
                largeScreen: true,
                enLargeClicked: null,
                riskScoreProgressPercentage: [],
                riskScoreProgressColor: [],
                sortedCount: null,
                zeroArray: [],
                sortedArray: [],
                zeroCount: null,
                pageName: 'Threat Score Widget'
            }
        },
        methods: {
            is_send_threat_email_disabled() {
                let role_string = this.getStatus(this.getEnterpriseStatus);
                return !(role_string != 'Pending' && role_string != 'In Analysis' && role_string != 'Inactive');
            },
            sendThreatEmail(enterprise_id) {
                $("#risk-score-container #send-threat-email-partner-button-large").css("display", "none");
                $("#risk-score-container #send-threat-email-partner-indicator-large").css("display", "block");
                $("#risk-score-container #send-threat-email-partner-button").css("display", "none");
                $("#risk-score-container #send-threat-email-partner-indicator").css("display", "block");
                let log_start = Date.now();
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/send_risk_email';
                let body = {
                    "enterprise_id": enterprise_id
                };
                this.$http.post(path, body).then(response => {
                    this.saveLog(this, this.pageName, ' Threat Mail sent successfull.', this.getDurationInSeconds(log_start, Date.now()), null);
                    this.sendThreatEmailSuccessCallback(response.data);
                    $("#risk-score-container #send-threat-email-partner-button").css("display", "block");
                    $("#risk-score-container #send-threat-email-partner-indicator").css("display", "none");
                    $("#risk-score-container #send-threat-email-partner-button-large").css("display", "block");
                    $("#risk-score-container #send-threat-email-partner-indicator-large").css("display", "none");
                }, response => {
                    this.saveLog(this, this.pageName, ' Threat Mail sent error. ', this.getDurationInSeconds(log_start, Date.now()), null);
                    this.showErrorMessage("Couldn't send Threat Mail. Please contact with support.");
                    $("#risk-score-container #send-threat-email-partner-button").css("display", "block");
                    $("#risk-score-container #send-threat-email-partner-indicator").css("display", "none");
                    $("#risk-score-container #send-threat-email-partner-button-large").css("display", "block");
                    $("#risk-score-container #send-threat-email-partner-indicator-large").css("display", "none");
                });
            },
            sendThreatEmailSuccessCallback(data) {
                if (data.return_code === Constants.ReturnCodes.ArgumentError) {
                    this.showErrorMessage(data.error_message);
                } else if (data.return_code === Constants.ReturnCodes.Success) {
                    this.showSuccessMessage(data.data)
                }
            },
            onCategorySelect(menuItem) {
                let log_start = Date.now();
                this.selectedCategoryItem = null;
                this.$nextTick(function () {
                    this.selectedCategoryItem = menuItem;
                    this.refreshRightDiv();
                });
                this.setSelectedRiskScoreItem(menuItem);
                this.saveLog(this, this.pageName, this.pageName + ' category clicked. Category: (' + menuItem.text + ')', this.getDurationInSeconds(log_start, Date.now()), null);
            },
            setSubRiskSource() {
                var sub_risk_source = null;
                if (this.riskScoreItem.sub_risks)
                    for (var i = 0; i < this.riskScoreItem.sub_risks.length; i++) {
                        if (this.selectedCategoryItem.text === "Threats On Data Breach") {
                            if (this.riskScoreItem.sub_risks[i].risk_group_enum_no === 1) {
                                sub_risk_source = this.riskScoreItem.sub_risks[i];
                            }
                        } else if (this.selectedCategoryItem.text === "Threats On Endpoints") {
                            if (this.riskScoreItem.sub_risks[i].risk_group_enum_no === 2) {
                                sub_risk_source = this.riskScoreItem.sub_risks[i];
                            }
                        } else if (this.selectedCategoryItem.text === "Threats On Servers") {
                            if (this.riskScoreItem.sub_risks[i].risk_group_enum_no === 3) {
                                sub_risk_source = this.riskScoreItem.sub_risks[i];
                            }
                        } else if (this.selectedCategoryItem.text === "Threats On Network Security") {
                            if (this.riskScoreItem.sub_risks[i].risk_group_enum_no === 4) {
                                sub_risk_source = this.riskScoreItem.sub_risks[i];
                            }
                        } else if (this.selectedCategoryItem.text === "Threats On Brand & User") {
                            if (this.riskScoreItem.sub_risks[i].risk_group_enum_no === 5) {
                                sub_risk_source = this.riskScoreItem.sub_risks[i];
                            }
                        }
                    }

                if (this.selectedCategoryItem.text !== "Overall Threat")
                    this.$refs.subRiskDashboardView.bindData(sub_risk_source, this.riskScoreItem.customer_name);
            },
            refreshRightDiv() {
                if (this.selectedCategoryItem != null) {
                    var selectedPage = this.selectedCategoryItem.text;
                    this.setSubRiskSource();

                    if (selectedPage == "Overall Threat") {
                        this.subRiskSelected = false;
                        this.overallRiskSelected = true;
                    } else if (selectedPage == "Threats On Data Breach") {
                        this.overallRiskSelected = false;
                        this.subRiskSelected = true;
                    } else if (selectedPage == "Threats On Endpoints") {
                        this.overallRiskSelected = false;
                        this.subRiskSelected = true;
                    } else if (selectedPage == "Threats On Servers") {
                        this.overallRiskSelected = false;
                        this.subRiskSelected = true;
                    } else if (selectedPage == "Threats On Network Security") {
                        this.overallRiskSelected = false;
                        this.subRiskSelected = true;
                    } else if (selectedPage == "Threats On Brand & User") {
                        this.overallRiskSelected = false;
                        this.subRiskSelected = true;
                    }
                }
            },
            onEnlargeClick() {
                // if(this.largeScreen === false){
                //     this.largeScreen = true;
                // }
                // else{
                //     this.largeScreen = false;
                // }
                let log_start = Date.now();
                this.enLargeClicked = this.getDashboardEnlargedItem;
                if (this.enLargeClicked != null) {
                    this.largeScreen = true;
                    this.saveLog(this, this.pageName, this.pageName + ' minimized.', this.getDurationInSeconds(log_start, Date.now()), null);
                } else {
                    this.largeScreen = false;
                    this.saveLog(this, this.pageName, this.pageName + ' maximized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                // this.largeScreen = !this.largeScreen;
                this.setDashboardEnlargedItem(this.itemNumber);
            },
            getRiskScoreList() {
                let log_start = Date.now();
                this.loading = true;

                var path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/risk_score';
                this.$http.get(path)
                    .then(response => {
                        if (response.data === "null") {
                            this.loading = false;
                            return;
                        }
                        //Sort Risk Score Start...
                        response.data.sub_risks.sort(function (a, b) {
                            return a.percentage - b.percentage;
                        });
                        response.data.sub_risks.reverse();
                        for (var i = 0; i < response.data.sub_risks.length; i++) {
                            if (response.data.sub_risks[i].percentage !== 0) {
                                this.sortedArray[i] = response.data.sub_risks[i];
                                this.sortedCount++;
                            } else {
                                this.zeroArray[i] = response.data.sub_risks[i];
                                this.zeroCount++;
                            }
                        }

                        this.zeroArray.sort(function (a, b) {
                            return a.risk_group_enum_no - b.risk_group_enum_no;
                        });

                        for (var i = 0; i < this.zeroCount; i++) {
                            this.sortedArray[this.sortedCount + i] = this.zeroArray[i];
                        }

                        for (var i = 0; i < this.sortedArray.length; i++) {
                            this.sortedArray[i].risk_elements.sort(function (a, b) {
                                return a.percentage - b.percentage;
                            });

                            this.sortedArray[i].risk_elements.reverse();
                        }

                        RISK_SCORE_MENU_ITEM_TEXTS[0] = "Overall Threat";
                        for (var i = 0; i < RISK_SCORE_MENU_ITEM_COUNT - 1; i++) {
                            RISK_SCORE_MENU_ITEM_TEXTS[i + 1] = this.sortedArray[i].risk_group_header;
                        }
                        //Sort Risk Score End...
                        //Risk Score Percentage For Progress Bar Start...
                        this.riskScoreProgressPercentage[0] = response.data.overall_risk_percent.toFixed();
                        for (var i = 0; i < RISK_SCORE_MENU_ITEM_COUNT - 1; i++) {
                            this.riskScoreProgressPercentage[i + 1] = this.sortedArray[i].percentage.toFixed();
                        }

                        for (var i = 0; i < RISK_SCORE_MENU_ITEM_COUNT; i++) {
                            if (this.riskScoreProgressPercentage[i] == 0) {
                                this.riskScoreProgressPercentage[i] = 1
                            }
                        }
                        //Risk Score Percentage For Progress Bar End...

                        //Risk Score Color Code For Progress Bar Start...
                        this.riskScoreProgressColor[0] = "#" + response.data.overall_risk_bg;
                        for (var i = 0; i < RISK_SCORE_MENU_ITEM_COUNT - 1; i++) {
                            this.riskScoreProgressColor[i + 1] = "#" + this.sortedArray[i].background;
                        }
                        //Risk Score Color Code For Progress Bar End...

                        this.selectedCategoryItem = this.getSelectedRiskScoreItem;
                        var items = [];
                        for (var i = 0; i < RISK_SCORE_MENU_ITEM_COUNT; i++) {
                            var item = {
                                id: this.uuidv4(),
                                enumNo: i,
                                text: RISK_SCORE_MENU_ITEM_TEXTS[i],
                                color: MENU_ITEM_COLOR,
                                progress: this.riskScoreProgressPercentage[i],
                                progressColor: this.riskScoreProgressColor[i],
                                selectedColor: "white",
                                selected: false
                            };


                            if (this.selectedCategoryItem != null) {
                                item.selected = this.selectedCategoryItem.text === item.text;
                                if (item.selected) {
                                    this.$nextTick(function () {
                                        this.selectedCategoryItem = item;
                                    });
                                }
                            } else {
                                item["selected"] = true;
                                this.selectedCategoryItem = item;
                                this.setSelectedRiskScoreItem(item);
                            }
                            items.push(item)
                        }
                        this.riskScoreMenuList = [
                            {
                                type: "selectableProgress",
                                text: "CATEGORY",
                                color: MENU_TITLE_COLOR,
                                backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                                open: true,
                                items: items
                            }
                        ];

                        this.riskScoreItem = response.data;
                        this.refreshRightDiv();
                        this.$emit('loaded', 'risk-score', this.getDurationInSeconds(log_start, Date.now()));
                        this.loading = false;
                    }, response => {
                        this.loading = false;
                    });
            },
            checkLargePage() {
                this.enLargeClicked = this.getDashboardEnlargedItem;
                if (this.enLargeClicked == this.itemNumber) {
                    this.largeScreen = false;
                }

            },
            selectRisk(selectedItem, enumNo, percentage, background) {
                let log_start = Date.now();
                var selectedItemFromOverallRisk = {
                    id: this.uuidv4(),
                    enumNo: enumNo,
                    text: selectedItem,
                    color: MENU_ITEM_COLOR,
                    progress: percentage,
                    progressColor: background,
                    selectedColor: "white",
                    selected: false
                };
                this.setSelectedRiskScoreItem(selectedItemFromOverallRisk);
                this.selectedCategoryItem = this.getSelectedRiskScoreItem;
                var items = [];
                for (var i = 0; i < RISK_SCORE_MENU_ITEM_COUNT; i++) {
                    var item = {
                        id: this.uuidv4(),
                        enumNo: i,
                        text: RISK_SCORE_MENU_ITEM_TEXTS[i],
                        color: MENU_ITEM_COLOR,
                        progress: this.riskScoreProgressPercentage[i],
                        progressColor: this.riskScoreProgressColor[i],
                        selectedColor: "white",
                        selected: false
                    };
                    if (this.selectedCategoryItem != null) {
                        item.selected = this.selectedCategoryItem.text === item.text;
                        if (item.selected) {
                            this.$nextTick(function () {
                                this.selectedCategoryItem = item;
                            });
                        }
                    } else {
                        item["selected"] = true;
                        this.selectedCategoryItem = item;
                        this.setSelectedRiskScoreItem(item);
                    }
                    items.push(item)
                }
                this.riskScoreMenuList = [
                    {
                        type: "selectableProgress",
                        text: "CATEGORY",
                        color: MENU_TITLE_COLOR,
                        backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                        open: true,
                        items: items
                    }
                ];

                this.refreshRightDiv();
                this.saveLog(this, this.pageName, this.pageName + ' Sub Category clicked under Overall Threat. Sub-Category: (' + selectedItem + ')', this.getDurationInSeconds(log_start, Date.now()), null);
            },
            ...mapActions([
                "setDashboardEnlargedItem",
                "setSelectedRiskScoreItem"
            ])
        },
        computed: {
            ...mapGetters([
                "getSelectedRiskScoreItem",
                "getDashboardEnlargedItem",
                "getComodoUserLogo"
            ])
        },
        mounted() {
        },
        beforeMount() {
            this.checkLargePage();
            this.getRiskScoreList();
        }
    }
</script>

<style scoped>
    h4 {
        font-family: Digital-Serial-Regular;
    }

    .partner-is-calculating-div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .text-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .text {
        fill: white;
        font-family: Digital-Serial-Bold;
        font-size: 20px;
    }

    .small-text {
        fill: #416477;
        font-family: Digital-Serial-Bold;
        font-size: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/risk-score/RiskScore.vue